// extracted by mini-css-extract-plugin
export default {"leftColumn":"PersonUpdatePage_leftColumn__t4TF4","rightColumn":"PersonUpdatePage_rightColumn__0LuFo"};